const AlertSvg = ({
  height = 30,
  width = 30,
  viewBox = '0 0 30 30',
  stroke = '#EB1919',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  stroke?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M15 13.75V20M15 26.25C8.7868 26.25 3.75 21.2132 3.75 15C3.75 8.7868 8.7868 3.75 15 3.75C21.2132 3.75 26.25 8.7868 26.25 15C26.25 21.2132 21.2132 26.25 15 26.25ZM15.0623 10V10.125L14.9377 10.1252V10H15.0623Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AlertSvg;
